import React from 'react'
import Blog from '../Component4/Blog/Blog'
import Contect from '../Component4/Contect/Contect';
import Map from '../Component4/Map/Map';
import Navbar from '../Component/Nvabar/Navbar';
import Footer from '../Component/Footer/Footer'

const Pages4 = () => {
  return (
    <>
    <Navbar/>
    <Blog/>
    <Contect/>
    <Map/>
    <Footer/>
    </>
  )
}

export default Pages4